import WindPlot from "../wind";
import WeatherPlot from "../weather";
import { getStationData } from "../util";
import Box from "@mui/material/Box";
import PressurePlot from "../pressure";


export default function Garda ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "TOR", "garda", "QFF_BOZ_GHE");

  return (
    <div>
      <title>Gardasee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Gardasee</h2>
          <h3>Torbole</h3>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <PressurePlot qff={qff} label="Bozen − Ghedi" label_plus="Nordwind (Peler)" label_minus="Südwind (Ora)" />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
          <a href="https://www.limmattalerwetter.ch/forecast/lake_garda.webp">
            <img
              className="windplot"
              src="https://www.limmattalerwetter.ch/forecast/lake_garda.webp"
              alt="Map of probability of wind exceeding threshold"
            />
          </a>
        </div>
      </div>
    </div>
  );
};
